import React, { Component } from "react";
import { Container, Alert } from "react-bootstrap";
import Info from "../Elements/Info";

export default class Home extends Component {
  render() {
    return (
      <React.Fragment>
        <Container className="mb-4">
          <Alert variant={"primary"}>Chaban Oxytec5s control</Alert>
          <Info />
        </Container>
      </React.Fragment>
    ); // end of "render" return
  } // end of render
} // end of class Home
